/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VoteRouteImport } from './routes/vote'
import { Route as TournamentsRouteImport } from './routes/tournaments'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ScoutedRouteImport } from './routes/scouted'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PlayRouteImport } from './routes/play'
import { Route as LobbiesRouteImport } from './routes/lobbies'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as BriefsRouteImport } from './routes/briefs'
import { Route as UsernameRouteImport } from './routes/$username'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GenresIndexRouteImport } from './routes/genres.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ArIndexRouteImport } from './routes/ar/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TournamentsIdRouteImport } from './routes/tournaments.$id'
import { Route as SupporterPlaylistsRouteImport } from './routes/supporter.playlists'
import { Route as SupportIdRouteImport } from './routes/support.$id'
import { Route as StudioReviewRouteImport } from './routes/studio.review'
import { Route as RoomCodeRouteImport } from './routes/room.$code'
import { Route as PacksNewRouteImport } from './routes/packs.new'
import { Route as GenresProposeRouteImport } from './routes/genres.propose'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BeatBattlesGenreRouteImport } from './routes/beat-battles.$genre'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as TournamentsIdShowcaseRouteImport } from './routes/tournaments.$id.showcase'

const VoteRoute = VoteRouteImport.update({
  id: '/vote',
  path: '/vote',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsRoute = TournamentsRouteImport.update({
  id: '/tournaments',
  path: '/tournaments',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutedRoute = ScoutedRouteImport.update({
  id: '/scouted',
  path: '/scouted',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const LobbiesRoute = LobbiesRouteImport.update({
  id: '/lobbies',
  path: '/lobbies',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefsRoute = BriefsRouteImport.update({
  id: '/briefs',
  path: '/briefs',
  getParentRoute: () => rootRouteImport,
} as any)
const UsernameRoute = UsernameRouteImport.update({
  id: '/$username',
  path: '/$username',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GenresIndexRoute = GenresIndexRouteImport.update({
  id: '/genres/',
  path: '/genres/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArIndexRoute = ArIndexRouteImport.update({
  id: '/ar/',
  path: '/ar/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsIdRoute = TournamentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TournamentsRoute,
} as any)
const SupporterPlaylistsRoute = SupporterPlaylistsRouteImport.update({
  id: '/supporter/playlists',
  path: '/supporter/playlists',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIdRoute = SupportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SupportRoute,
} as any)
const StudioReviewRoute = StudioReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => StudioRoute,
} as any)
const RoomCodeRoute = RoomCodeRouteImport.update({
  id: '/room/$code',
  path: '/room/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const PacksNewRoute = PacksNewRouteImport.update({
  id: '/packs/new',
  path: '/packs/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GenresProposeRoute = GenresProposeRouteImport.update({
  id: '/genres/propose',
  path: '/genres/propose',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BeatBattlesGenreRoute = BeatBattlesGenreRouteImport.update({
  id: '/beat-battles/$genre',
  path: '/beat-battles/$genre',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsIdShowcaseRoute = TournamentsIdShowcaseRouteImport.update({
  id: '/showcase',
  path: '/showcase',
  getParentRoute: () => TournamentsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$username': typeof UsernameRoute
  '/briefs': typeof BriefsRoute
  '/cookies': typeof CookiesRoute
  '/faq': typeof FaqRoute
  '/feed': typeof FeedRoute
  '/inbox': typeof InboxRoute
  '/leaderboard': typeof LeaderboardRoute
  '/legal': typeof LegalRoute
  '/lobbies': typeof LobbiesRoute
  '/play': typeof PlayRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/scouted': typeof ScoutedRoute
  '/settings': typeof SettingsRoute
  '/studio': typeof StudioRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/terms': typeof TermsRoute
  '/tournaments': typeof TournamentsRouteWithChildren
  '/vote': typeof VoteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/beat-battles/$genre': typeof BeatBattlesGenreRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/genres/propose': typeof GenresProposeRoute
  '/packs/new': typeof PacksNewRoute
  '/room/$code': typeof RoomCodeRoute
  '/studio/review': typeof StudioReviewRoute
  '/support/$id': typeof SupportIdRoute
  '/supporter/playlists': typeof SupporterPlaylistsRoute
  '/tournaments/$id': typeof TournamentsIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/ar/': typeof ArIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/genres/': typeof GenresIndexRoute
  '/tournaments/$id/showcase': typeof TournamentsIdShowcaseRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$username': typeof UsernameRoute
  '/briefs': typeof BriefsRoute
  '/cookies': typeof CookiesRoute
  '/faq': typeof FaqRoute
  '/feed': typeof FeedRoute
  '/inbox': typeof InboxRoute
  '/leaderboard': typeof LeaderboardRoute
  '/legal': typeof LegalRoute
  '/lobbies': typeof LobbiesRoute
  '/play': typeof PlayRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/scouted': typeof ScoutedRoute
  '/settings': typeof SettingsRoute
  '/studio': typeof StudioRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/terms': typeof TermsRoute
  '/tournaments': typeof TournamentsRouteWithChildren
  '/vote': typeof VoteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/beat-battles/$genre': typeof BeatBattlesGenreRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/genres/propose': typeof GenresProposeRoute
  '/packs/new': typeof PacksNewRoute
  '/room/$code': typeof RoomCodeRoute
  '/studio/review': typeof StudioReviewRoute
  '/support/$id': typeof SupportIdRoute
  '/supporter/playlists': typeof SupporterPlaylistsRoute
  '/tournaments/$id': typeof TournamentsIdRouteWithChildren
  '/admin': typeof AdminIndexRoute
  '/ar': typeof ArIndexRoute
  '/blog': typeof BlogIndexRoute
  '/genres': typeof GenresIndexRoute
  '/tournaments/$id/showcase': typeof TournamentsIdShowcaseRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$username': typeof UsernameRoute
  '/briefs': typeof BriefsRoute
  '/cookies': typeof CookiesRoute
  '/faq': typeof FaqRoute
  '/feed': typeof FeedRoute
  '/inbox': typeof InboxRoute
  '/leaderboard': typeof LeaderboardRoute
  '/legal': typeof LegalRoute
  '/lobbies': typeof LobbiesRoute
  '/play': typeof PlayRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/rules': typeof RulesRoute
  '/scouted': typeof ScoutedRoute
  '/settings': typeof SettingsRoute
  '/studio': typeof StudioRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/terms': typeof TermsRoute
  '/tournaments': typeof TournamentsRouteWithChildren
  '/vote': typeof VoteRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/beat-battles/$genre': typeof BeatBattlesGenreRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/genres/propose': typeof GenresProposeRoute
  '/packs/new': typeof PacksNewRoute
  '/room/$code': typeof RoomCodeRoute
  '/studio/review': typeof StudioReviewRoute
  '/support/$id': typeof SupportIdRoute
  '/supporter/playlists': typeof SupporterPlaylistsRoute
  '/tournaments/$id': typeof TournamentsIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/ar/': typeof ArIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/genres/': typeof GenresIndexRoute
  '/tournaments/$id/showcase': typeof TournamentsIdShowcaseRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$username'
    | '/briefs'
    | '/cookies'
    | '/faq'
    | '/feed'
    | '/inbox'
    | '/leaderboard'
    | '/legal'
    | '/lobbies'
    | '/play'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/scouted'
    | '/settings'
    | '/studio'
    | '/support'
    | '/terms'
    | '/tournaments'
    | '/vote'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/beat-battles/$genre'
    | '/blog/$slug'
    | '/genres/propose'
    | '/packs/new'
    | '/room/$code'
    | '/studio/review'
    | '/support/$id'
    | '/supporter/playlists'
    | '/tournaments/$id'
    | '/admin/'
    | '/ar/'
    | '/blog/'
    | '/genres/'
    | '/tournaments/$id/showcase'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$username'
    | '/briefs'
    | '/cookies'
    | '/faq'
    | '/feed'
    | '/inbox'
    | '/leaderboard'
    | '/legal'
    | '/lobbies'
    | '/play'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/scouted'
    | '/settings'
    | '/studio'
    | '/support'
    | '/terms'
    | '/tournaments'
    | '/vote'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/beat-battles/$genre'
    | '/blog/$slug'
    | '/genres/propose'
    | '/packs/new'
    | '/room/$code'
    | '/studio/review'
    | '/support/$id'
    | '/supporter/playlists'
    | '/tournaments/$id'
    | '/admin'
    | '/ar'
    | '/blog'
    | '/genres'
    | '/tournaments/$id/showcase'
  id:
    | '__root__'
    | '/'
    | '/$username'
    | '/briefs'
    | '/cookies'
    | '/faq'
    | '/feed'
    | '/inbox'
    | '/leaderboard'
    | '/legal'
    | '/lobbies'
    | '/play'
    | '/pricing'
    | '/privacy'
    | '/rules'
    | '/scouted'
    | '/settings'
    | '/studio'
    | '/support'
    | '/terms'
    | '/tournaments'
    | '/vote'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/beat-battles/$genre'
    | '/blog/$slug'
    | '/genres/propose'
    | '/packs/new'
    | '/room/$code'
    | '/studio/review'
    | '/support/$id'
    | '/supporter/playlists'
    | '/tournaments/$id'
    | '/admin/'
    | '/ar/'
    | '/blog/'
    | '/genres/'
    | '/tournaments/$id/showcase'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UsernameRoute: typeof UsernameRoute
  BriefsRoute: typeof BriefsRoute
  CookiesRoute: typeof CookiesRoute
  FaqRoute: typeof FaqRoute
  FeedRoute: typeof FeedRoute
  InboxRoute: typeof InboxRoute
  LeaderboardRoute: typeof LeaderboardRoute
  LegalRoute: typeof LegalRoute
  LobbiesRoute: typeof LobbiesRoute
  PlayRoute: typeof PlayRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  RulesRoute: typeof RulesRoute
  ScoutedRoute: typeof ScoutedRoute
  SettingsRoute: typeof SettingsRoute
  StudioRoute: typeof StudioRouteWithChildren
  SupportRoute: typeof SupportRouteWithChildren
  TermsRoute: typeof TermsRoute
  TournamentsRoute: typeof TournamentsRouteWithChildren
  VoteRoute: typeof VoteRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  BeatBattlesGenreRoute: typeof BeatBattlesGenreRoute
  BlogSlugRoute: typeof BlogSlugRoute
  GenresProposeRoute: typeof GenresProposeRoute
  PacksNewRoute: typeof PacksNewRoute
  RoomCodeRoute: typeof RoomCodeRoute
  SupporterPlaylistsRoute: typeof SupporterPlaylistsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ArIndexRoute: typeof ArIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  GenresIndexRoute: typeof GenresIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vote': {
      id: '/vote'
      path: '/vote'
      fullPath: '/vote'
      preLoaderRoute: typeof VoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments': {
      id: '/tournaments'
      path: '/tournaments'
      fullPath: '/tournaments'
      preLoaderRoute: typeof TournamentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scouted': {
      id: '/scouted'
      path: '/scouted'
      fullPath: '/scouted'
      preLoaderRoute: typeof ScoutedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lobbies': {
      id: '/lobbies'
      path: '/lobbies'
      fullPath: '/lobbies'
      preLoaderRoute: typeof LobbiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/briefs': {
      id: '/briefs'
      path: '/briefs'
      fullPath: '/briefs'
      preLoaderRoute: typeof BriefsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$username': {
      id: '/$username'
      path: '/$username'
      fullPath: '/$username'
      preLoaderRoute: typeof UsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genres/': {
      id: '/genres/'
      path: '/genres'
      fullPath: '/genres/'
      preLoaderRoute: typeof GenresIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ar/': {
      id: '/ar/'
      path: '/ar'
      fullPath: '/ar/'
      preLoaderRoute: typeof ArIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments/$id': {
      id: '/tournaments/$id'
      path: '/$id'
      fullPath: '/tournaments/$id'
      preLoaderRoute: typeof TournamentsIdRouteImport
      parentRoute: typeof TournamentsRoute
    }
    '/supporter/playlists': {
      id: '/supporter/playlists'
      path: '/supporter/playlists'
      fullPath: '/supporter/playlists'
      preLoaderRoute: typeof SupporterPlaylistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/$id': {
      id: '/support/$id'
      path: '/$id'
      fullPath: '/support/$id'
      preLoaderRoute: typeof SupportIdRouteImport
      parentRoute: typeof SupportRoute
    }
    '/studio/review': {
      id: '/studio/review'
      path: '/review'
      fullPath: '/studio/review'
      preLoaderRoute: typeof StudioReviewRouteImport
      parentRoute: typeof StudioRoute
    }
    '/room/$code': {
      id: '/room/$code'
      path: '/room/$code'
      fullPath: '/room/$code'
      preLoaderRoute: typeof RoomCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packs/new': {
      id: '/packs/new'
      path: '/packs/new'
      fullPath: '/packs/new'
      preLoaderRoute: typeof PacksNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genres/propose': {
      id: '/genres/propose'
      path: '/genres/propose'
      fullPath: '/genres/propose'
      preLoaderRoute: typeof GenresProposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beat-battles/$genre': {
      id: '/beat-battles/$genre'
      path: '/beat-battles/$genre'
      fullPath: '/beat-battles/$genre'
      preLoaderRoute: typeof BeatBattlesGenreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments/$id/showcase': {
      id: '/tournaments/$id/showcase'
      path: '/showcase'
      fullPath: '/tournaments/$id/showcase'
      preLoaderRoute: typeof TournamentsIdShowcaseRouteImport
      parentRoute: typeof TournamentsIdRoute
    }
  }
}

interface StudioRouteChildren {
  StudioReviewRoute: typeof StudioReviewRoute
}

const StudioRouteChildren: StudioRouteChildren = {
  StudioReviewRoute: StudioReviewRoute,
}

const StudioRouteWithChildren =
  StudioRoute._addFileChildren(StudioRouteChildren)

interface SupportRouteChildren {
  SupportIdRoute: typeof SupportIdRoute
}

const SupportRouteChildren: SupportRouteChildren = {
  SupportIdRoute: SupportIdRoute,
}

const SupportRouteWithChildren =
  SupportRoute._addFileChildren(SupportRouteChildren)

interface TournamentsIdRouteChildren {
  TournamentsIdShowcaseRoute: typeof TournamentsIdShowcaseRoute
}

const TournamentsIdRouteChildren: TournamentsIdRouteChildren = {
  TournamentsIdShowcaseRoute: TournamentsIdShowcaseRoute,
}

const TournamentsIdRouteWithChildren = TournamentsIdRoute._addFileChildren(
  TournamentsIdRouteChildren,
)

interface TournamentsRouteChildren {
  TournamentsIdRoute: typeof TournamentsIdRouteWithChildren
}

const TournamentsRouteChildren: TournamentsRouteChildren = {
  TournamentsIdRoute: TournamentsIdRouteWithChildren,
}

const TournamentsRouteWithChildren = TournamentsRoute._addFileChildren(
  TournamentsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UsernameRoute: UsernameRoute,
  BriefsRoute: BriefsRoute,
  CookiesRoute: CookiesRoute,
  FaqRoute: FaqRoute,
  FeedRoute: FeedRoute,
  InboxRoute: InboxRoute,
  LeaderboardRoute: LeaderboardRoute,
  LegalRoute: LegalRoute,
  LobbiesRoute: LobbiesRoute,
  PlayRoute: PlayRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  RulesRoute: RulesRoute,
  ScoutedRoute: ScoutedRoute,
  SettingsRoute: SettingsRoute,
  StudioRoute: StudioRouteWithChildren,
  SupportRoute: SupportRouteWithChildren,
  TermsRoute: TermsRoute,
  TournamentsRoute: TournamentsRouteWithChildren,
  VoteRoute: VoteRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  BeatBattlesGenreRoute: BeatBattlesGenreRoute,
  BlogSlugRoute: BlogSlugRoute,
  GenresProposeRoute: GenresProposeRoute,
  PacksNewRoute: PacksNewRoute,
  RoomCodeRoute: RoomCodeRoute,
  SupporterPlaylistsRoute: SupporterPlaylistsRoute,
  AdminIndexRoute: AdminIndexRoute,
  ArIndexRoute: ArIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  GenresIndexRoute: GenresIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
